var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"container"},[_c('div',{staticClass:"content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"widget-box",domProps:{"innerHTML":_vm._s(_vm.store.terms_conditions)}})])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-heading"},[_c('h1',[_vm._v("Terms and Conditions")])])
}]

export { render, staticRenderFns }